<mat-card *ngIf="order && documents && documents.length > 0">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="/buscar/{{order.id}}">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title fxLayout="row">
        <div fxFlex="30">Órden: {{order.id}} Línea: {{order.items[0].line}}</div>
        <div fxFlex>Fecha de publicación:
          <span *ngFor="let dt of order.items[0].publishDates">{{dt | date: 'MMM dd yyyy '}}</span>
        </div>
        <div>Estado: {{order.internalStatus}}</div>
      </mat-card-title>
      <mat-card-subtitle fxLayout="row">
        <div fxFlex="30">Cliente: {{order.clientName}} - ({{order.nit}})</div>
        <div fxFlex>Notas: {{order.items[0].notes}}</div>
        <div>Cantidad: {{order.items[0].quantity}}</div>
      </mat-card-subtitle>
    </div>
  </div>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab *ngFor="let doc of documents" label="Documento {{doc.index}}">
        <div class="tab-content">
          <mat-accordion>
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title> Historial </mat-panel-title>
              </mat-expansion-panel-header>
              <app-order-document-history [orderId]="order.id" [line]="doc.line" [index]="doc.index"></app-order-document-history>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> Contenido </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngFor="let documentData of doc.data">
                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
                  <h2 class="resume-title">{{documentData.key}}</h2>
                  <hr>
                  <div class="content" [innerHTML]="documentData.value"></div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="(!order || !documents || documents.length === 0) && !loading">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="/buscar/{{order.id}}">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title>
        No se tiene registro de la digitación de este item.
      </mat-card-title>
      <mat-card-subtitle fxLayout="row">
        Esto se debe a que la orden no se validó, o que el item nunca inició digitación.
      </mat-card-subtitle>
    </div>
  </div>
</mat-card>
